export default function capitalize(data) {
    return data.charAt(0).toUpperCase() + data.slice(1);
}
